import {useState, useEffect} from "react"
import { useSelector } from "react-redux";
import Table from "./Table";
import { Tabs, Button, Select } from "antd";
import IprFrame from "./IprFrame/IprFrame";
import { CloseCircleOutlined } from "@ant-design/icons";
import AttachmentTable from "./AttachmentTable";
import { UnorderedListOutlined } from "@ant-design/icons";
import { primaryColor } from "colors-config";
import { ReactComponent as EyeIcon } from "../../assets/EyeIcon.svg";
import TeethType from "Components/TeethType/TeethType";

const IPR = ({ showIprTable, setShowIprTable }) => {
  const iprDetails = useSelector((state) => state.model.iprDetails);
  const attachmentDetails = useSelector(
    (state) => state.model.attachtmentDetails
  );
  const showIpr = useSelector((state) => state.model.showIpr);
  const upperModelIndex = useSelector((state) => state.model.upperModelIndex);
  const lowerModelIndex = useSelector((state) => state.model.lowerModelIndex);
  const anim = useSelector((state) => state.model.iprAnimation);
  const [activeKey, setActiveKey] = useState('1');
  const [tableData,setTableData] = useState([])
  const [iprCounts,setIprCounts] = useState([])
  const [attachmentCounts,setAttachmentCounts] = useState([])
  const [chartValue, setChartValue] = useState("fdi");

  useEffect(() => {
    let finalCounts = [];
    // console.log("iprDetailsiprDetails", iprDetails)
    // console.log("attachmentDetailsattachmentDetails", attachmentDetails)
    const iprDataCounts = iprDetails?.map((ipr) => ipr.aligner_count) || [];
    // console.log("iprCountsiprCounts", iprCounts)
    const attachmentDataCounts = attachmentDetails?.map((obj) => obj.aligner_count) || [];
    // console.log("attachmentCountsattachmentCounts", attachmentCounts)
    finalCounts = [...iprDataCounts, ...attachmentDataCounts];
    //  console.log("finalCountsfinalCounts", finalCounts)
    setTableData(finalCounts);
    setIprCounts(iprDataCounts);
    setAttachmentCounts(attachmentDataCounts)

  }, [iprDetails, attachmentDetails]);


  useEffect(() => {
    if (iprCounts.includes(upperModelIndex) || iprCounts.includes(lowerModelIndex)) {
      setActiveKey("1");
    } else if (attachmentCounts.includes(upperModelIndex) || attachmentCounts.includes(lowerModelIndex)) {
      setActiveKey("2");
    } else {
      setActiveKey("1");
    }
  }, [upperModelIndex, lowerModelIndex, iprCounts, attachmentCounts]);



  

  const items = [
    {
      key: "1",
      label: "IPR",
      children: (
        <Table
          iprData={iprDetails}
          upperModelIndex={upperModelIndex}
          lowerModelIndex={lowerModelIndex}
          showIprTable={showIprTable}
          setShowIprTable={setShowIprTable}
          chartValue={chartValue}
        />
      ),
    },
    {
      key: "2",
      label: "Attachment",
      children: (
        <AttachmentTable
          upperModelIndex={upperModelIndex}
          lowerModelIndex={lowerModelIndex}
          showIprTable={showIprTable}
          chartValue={chartValue}
          pressure={false}
        />
      ),
    },
      {
      key: "3",
      label: "Pressure Line",
      children: (
        <AttachmentTable
          upperModelIndex={upperModelIndex}
          lowerModelIndex={lowerModelIndex}
          showIprTable={showIprTable}
          chartValue={chartValue}
          pressure={true}
        />
      ),
    },
  ];

  const onChangeTab = (key) => {
    // console.log("onChangeTabonChangeTab", key)s
    setActiveKey(key);
  };

  const handleStructureChange = (value) => {
    setChartValue(value);
  };
 
  return (
    <div className={`ipr-wrapper ${anim ? "show" : "hide"}`}>
      <div   className={"teeth-name-container"}>
      <TeethType
        teethTypeName={chartValue}
        onTeethTypeChange={handleStructureChange}
      />
      </div>
 
      {showIpr ? (
        <div className="wrapper-two">
          <div>
            <IprFrame
              upperModelIndex={upperModelIndex}
              lowerModelIndex={lowerModelIndex}
              chartValue={chartValue}
              iprData={iprDetails}
            />
          </div>

          {showIprTable ? (
            <>
              <div
                className="cross"
                onClick={() => setShowIprTable((prev) => !prev)}
              >
                <CloseCircleOutlined style={{color:"#fff"}}  />
              </div>
              <div
                className="bgg"
                onClick={() => setShowIprTable((prev) => !prev)}
              />
            </>
          ) : null}

          <div
            className={
              showIprTable ? "ipr-table-mobile-wrapper" : "ipr-table-wrapper"
            }
          >
            <Tabs
              defaultActiveKey="1"
              items={items}
              className={
                showIprTable ? "ipr-tabs-mobile-wrapper" : "ipr-tabs"
              }

              activeKey={activeKey}
              onChange={onChangeTab}
            />
          </div>
        </div>
      ) : null}
      {showIpr && (
        <div  className="view-list">
          <div className={ showIpr ? "teeth-name-container teeth-name-show" :"teeth-name-container"}>
      <TeethType
        teethTypeName={chartValue}
        onTeethTypeChange={handleStructureChange}
      />
      </div>
       <div
        className="list-icon"
          onClick={() => {
            if (
              tableData.includes(upperModelIndex) ||
              tableData.includes(lowerModelIndex)
            ) {
              setShowIprTable((prev) => !prev);
            }
          }}
       
          style={{
            display:"flex",
            alignItems:"center",
            opacity:
              tableData.includes(upperModelIndex) ||
              tableData.includes(lowerModelIndex)
                ? "1"
                : "0",
            cursor:
              tableData.includes(upperModelIndex) ||
              tableData.includes(lowerModelIndex)
                ? "pointer"
                : "auto",
          }}
        >
          <p style={{color:"#000"}}> View Details</p> <UnorderedListOutlined  style={{color:"#000"}}/>
        </div>
        </div>
    
      )}
      {/* {showIpr &&         tableData.includes(upperModelIndex) ||
                tableData.includes(lowerModelIndex) && (
        <div className="indicator-container">
          <Button
            className="indicator-btn"
            shape="round"
            onClick={() => {
              if (
                tableData.includes(upperModelIndex) ||
                tableData.includes(lowerModelIndex)
              ) {
                setShowIprTable((prev) => !prev);
              }
            }}
            icon={<EyeIcon />}
            style={{ background: primaryColor }}
          >
            IPR/Attachment Schedule
          </Button>
        </div>
      )} */}
      {showIpr &&
        (tableData.includes(upperModelIndex) ||
          tableData.includes(lowerModelIndex)) && (
          <div className="indicator-container">
            <Button
              className="indicator-btn"
              shape="round"
              onClick={() => {
                if (
                  tableData.includes(upperModelIndex) ||
                  tableData.includes(lowerModelIndex)
                ) {
                  setShowIprTable((prev) => !prev);
                }
              }}
              icon={<EyeIcon />}
              style={{ background: primaryColor }}
            >
              IPR/Attachment Schedule
            </Button>
          </div>
        )}

        <div  className={showIprTable ? "dr-app-names-wrapper" : "app-names-wrapper"}>
        <TeethType
        teethTypeName={chartValue}
        onTeethTypeChange={handleStructureChange}
      />
        </div>

      {showIpr && (
        <div
          className={showIprTable ? "dr-app-tooths-wrapper" : "dr-app-tooths"}
        >
          <IprFrame
            upperModelIndex={upperModelIndex}
            lowerModelIndex={lowerModelIndex}
            chartValue={chartValue}
            iprData={iprDetails}
          />
        </div>
      )}
    </div>
  );
};

export default IPR;
